export const OFF_BY_DEFAULT = [
  'omni.wireframe',
  'omni.slides',
  'omni.charts',
  'omni.mcp-bridge',
  'omni.ai-chrome',
  'omni.tool-eraser',
  'omni.comments',
  'omni.office',
  'omni.ai-learn',
  'omni.bloom-path',
  'omni.flashcards',
  'omni.concept-dots',
  'omni.live-apps',
  'omni.dashboards',
  'omni.infographics',
  'omni.calls',
  'omni.presence',
  'omni.share',
  'omni.kanban',
  'omni.calendar',
  'omni.tasks',
  'omni.svg-paste',
  'omni.hello',
]

const LEGACY = [
  'omni.wireframe',
  'omni.slides',
  'omni.charts',
  'omni.diagram-code',
  'omni.ai-core',
  'omni.ai-tools',
  'omni.ai-jobs',
  'omni.ai',
  'omni.ai-learn',
  'omni.ai-capture',
  'omni.mcp-bridge',
  'omni.ai-chrome',
  'omni.ai-transformers-js',
  'omni.ai-frame',
  'omni.web-notes',
]

const KEY = 'omni.off-by-default.v1'
const DONE_KEY = 'omni.off-by-default.done'

// one-time, so a person who turns a feature back on keeps it
export function switchOffOnce(store, storage) {
  let done = JSON.parse(storage.getItem(DONE_KEY) ?? 'null')
  if (done === null) {
    done = storage.getItem(KEY) ? [...LEGACY] : []
  }
  for (const id of OFF_BY_DEFAULT) {
    if (!done.includes(id)) {
      if (store.get(id)) store.setEnabled(id, false, 'off by default')
      done.push(id)
    }
  }
  storage.setItem(DONE_KEY, JSON.stringify(done))
  storage.setItem(KEY, '1')
}
// A plugin that cannot work without another. Old profiles switched
// Diagram as code off above, so the AI area answered every question with
// "the diagram language is not installed". One-time, like the step above:
// a person who turns it off again afterwards keeps it off.
const NEEDS = [['omni.ai-frame', 'omni.diagram-code']]
const NEEDS_KEY = 'omni.needs-on.done'

export function switchNeedsOnOnce(store, storage) {
  const done = JSON.parse(storage.getItem(NEEDS_KEY) ?? '[]')
  for (const [user, needed] of NEEDS) {
    const pair = `${user}>${needed}`
    if (done.includes(pair)) continue
    const entry = store.get(needed)
    if (store.get(user)?.enabled && entry && !entry.enabled) {
      store.setEnabled(needed, true, `needed by ${user}`)
    }
    done.push(pair)
  }
  storage.setItem(NEEDS_KEY, JSON.stringify(done))
}
